export function withCssUnit(input: number | string, unit: 'rem' | 'px' | 'em'): `${typeof input}${typeof unit}` {
  return `${input}${unit}`;
}

export function capitalze(str: string): string {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
